import axios from 'axios';
import { logout, getAccessToken } from './auth';

let host = window.location.hostname;
host += host === 'localhost' ? ':8080' : '';
const baseURL = `${window.location.protocol}//${host}/api`;

class Api {
  static buildRequest(url, method, customHeader, requestData) {
    const config = {
      baseURL,
      method,
      url,
      headers: { 'Content-Type': 'application/json' },
      validateStatus(status) {
        return (status >= 200) && (status <= 500);
      }
    };

    if (method === 'POST' || method === 'PATCH' || method === 'PUT') {
      config.data = requestData;
    }

    if (customHeader) {
      config.headers = Object.assign(config.headers, customHeader);
    }

    if (getAccessToken()) {
      config.headers = Object.assign(config.headers, {
        Authorization: `Bearer ${getAccessToken()}`
      });
    }
    Api.interceptResponse();
    return Api.makeRequest(config);
  }

  static makeRequest(config) {
    return axios(config);
  }

  static interceptResponse() {
    axios.interceptors.response.use((response) => {
      if (response.status === 401) {
        logout();
      }
      return response;
    }, error => Promise.reject(error));
  }
}

export default Api;



// WEBPACK FOOTER //
// ./src/utils/api.js